async function confirm() {
  const params = new URLSearchParams(location.search);
  const slug = params.get("slug");
  const token = params.get("token");
  const callbackUrl = params.get("callbackUrl");

  const $loading = document.getElementById("loading");
  const $error = document.getElementById("error");

  if (!$loading || !$error) {
    console.error("some nodes couldn't be found");
    return;
  }

  if (!slug || !token || !callbackUrl) {
    console.error("some URL params are missing");
    return;
  }

  const showError = (message: string) => {
    $loading.toggleAttribute("hidden", true);
    $error.textContent = message;
    $error.toggleAttribute("hidden", false);
  };

  let response: Response;
  try {
    response = await fetch("/api/confirmUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug, token }),
    });
  } catch (error) {
    showError(`Unexpected error: ${error.message}`);
    return;
  }

  if (response.status === 403) {
    showError("The link you used is invalid or has expired");
    return;
  }
  if (response.status !== 200) {
    showError(`Unexpected response status ${response.status}`);
    return;
  }

  // success
  location.href = callbackUrl;
}

document.addEventListener("DOMContentLoaded", confirm);
